import axios from '@fs/zion-axios'
import useStateManager from './useStateManager'
import useFetchData from './useFetchData'

const fetchEnableProfileSearchPermission = async () => {
  const { data } = await axios.get('/service/user/profile/users/CURRENT')
  return data?.searchable?.status === 'LISTED'
}

const updateProfileSearchPermission = (checked) =>
  axios.patch('/service/user/profile/users/CURRENT', { searchable: { status: checked ? 'LISTED' : 'UNLISTED' } })

export default function useProfileSearchPermission() {
  const { data: remoteProfileSearchPermission, loading: profileSearchPermissionLoading } = useFetchData(
    fetchEnableProfileSearchPermission,
    { initialData: false }
  )

  const { state: localProfileSearchPermission, handleChangeState: handleChangeProfileSearchPermission } =
    useStateManager(updateProfileSearchPermission)
  const profileSearchPermission = localProfileSearchPermission ?? remoteProfileSearchPermission

  return {
    profileSearchPermission,
    profileSearchPermissionLoading,
    handleChangeProfileSearchPermission,
  }
}
